import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { Page1 } from "./Introduction/Page1";
import { Page2 } from "./Introduction/Page2";
import { Page3 } from "./Introduction/Page3";

export const pathRoot = "/setupdata/introduction";

function Introduction() {
	const handleSaveFailure = (error) => {
		console.error(`Error saving data in ${pathRoot}: `, error);
		// history.push("/dashboard");
	};

	return (
		<>
			<Switch>
				<Route path={`${pathRoot}/1`}>
					<Page1></Page1>
				</Route>
				<Route path={`${pathRoot}/2`}>
					<Page2 />
				</Route>
				<Route path={`${pathRoot}/3`}>
					<Page3 onSaveFailure={handleSaveFailure} />
				</Route>
				<Redirect from={pathRoot} to={`${pathRoot}/1`} />
			</Switch>
		</>
	);
}

export { Introduction };
